import {GetConsultRefunds} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteGetConsultRefunds} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetConsultRefunds = (): GetConsultRefunds =>
	new RemoteGetConsultRefunds(
		makeBFFApiUrl(RefundFlowEndPoints.consultRefunds),
		makeAuthorizeHttpClientDecorator(),
	);
